import iosTheme from './ios/theme'
import iosLayout from './ios/layout'

import materialTheme from './material/theme'
import materialLayout from './material/layout'

export default (target, themeData) => {
  if (target === 'material') {
    return materialTheme(themeData) + materialLayout(themeData)
  } else {
    return iosTheme(themeData) + iosLayout(themeData)
  }
}



// WEBPACK FOOTER //
// ./src/template/index.js